class HolHomepageHero {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('[data-hol-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-hol-dot]'));
    this.activeIndex = 0;
    this.interval = Number(root.dataset.interval) || 8000;
    this.timer = null;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.show(index);
        this.restart();
      });
    });

    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());
    root.addEventListener('focusin', () => this.stop());
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) this.start();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else this.start();
    });

    this.show(0);
    this.start();
  }

  show(index) {
    if (!this.slides.length) return;

    this.activeIndex = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === this.activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));

      slide.querySelectorAll('[data-hol-slide-link]').forEach((link) => {
        link.tabIndex = isActive ? 0 : -1;
      });
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === this.activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-pressed', String(isActive));
    });
  }

  start() {
    if (this.reducedMotion || this.slides.length < 2 || this.timer || document.hidden) return;

    this.timer = window.setInterval(() => {
      this.show(this.activeIndex + 1);
    }, this.interval);
  }

  stop() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

function initialiseHolHomepages(scope = document) {
  scope.querySelectorAll('[data-hol-hero]').forEach((hero) => {
    if (hero.dataset.initialised === 'true') return;
    hero.dataset.initialised = 'true';
    new HolHomepageHero(hero);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialiseHolHomepages());
} else {
  initialiseHolHomepages();
}

document.addEventListener('shopify:section:load', (event) => {
  initialiseHolHomepages(event.target);
});
